import React from "react";
import { FaEnvelope } from "react-icons/fa";
import PropTypes from "prop-types";

import { useStateContext } from "../../../../../contextProvider";

const SendButton = ({ medicalStaffId, patientId, patientData, navigateToSendMessage }) => {

    const { setSelectedPatient, setSelectedPatientData, setDoctorPage } = useStateContext()

    return (
        <div style={{height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <FaEnvelope
            className="table-icon"
            color="#286F9E"
            onClick={() => {
                setSelectedPatient(patientId)
                setSelectedPatientData(patientData)
                localStorage.setItem('patient_id', String(patientId))
                localStorage.setItem('staff_id', String(medicalStaffId))
                localStorage.setItem('patient_data', JSON.stringify(patientData[0]))
                localStorage.setItem("patient_name", patientData[0].name);
                localStorage.setItem("patient_surname", patientData[0].surname);

                setDoctorPage('chat')
                navigateToSendMessage({ medicalStaffId: medicalStaffId, patientId: patientId });
            }}
        />
        </div>
    );
}

SendButton.propTypes = {
    medicalStaffId: PropTypes.number,
    patientId: PropTypes.number,
    navigateToSendMessage: PropTypes.func,
};

export default SendButton;
